const contactMeForm = {
    requiredField: 'This field is required',
    invalidEmail: 'Enter a valid email address',
    name: 'Name',
    namePlaceholder: 'Your name',
    email: 'Email',
    emailPlaceholder: 'you@company.com',
    message: 'Message',
    messagePlaceholder: 'What would you like to talk about?',
    submit: 'Send message',
};

export default contactMeForm;
